/**
 * Marca de "esta sessão já teve uma pesquisa" (RN-06).
 *
 * Vive no `sessionStorage`, e não no Redux, porque o estado do Redux zera no F5 —
 * e aí um simples recarregar valeria como sessão nova, deixando a segunda pesquisa
 * do dia aparecer. O `sessionStorage` é por aba e morre quando ela fecha, que é
 * exatamente o recorte de "sessão de uso" que a regra descreve.
 *
 * Isto NÃO é o teto: o teto é semanal e por pessoa, mora no banco da plataforma, e
 * sobrevive a trocar de navegador ou limpar dados. A marca aqui só evita duas
 * perguntas no mesmo dia de trabalho — perdê-la degrada para o teto, não para
 * "pergunta sempre".
 */
const CHAVE_SESSAO = 'arb.pesquisaSatisfacao.exibidaNaSessao';

export function lerMarcaDeSessao(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(CHAVE_SESSAO) === 'true';
  } catch {
    return false;
  }
}

export function marcarPesquisaNaSessao(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(CHAVE_SESSAO, 'true');
  } catch {
    // Navegador com storage bloqueado ainda tem o teto semanal do servidor; a
    // pesquisa não pode quebrar por causa da marca de conveniência.
  }
}
